export default __webpack_public_path__ + "static/media/photo 22.43e7b11b.jpg";